import { render, staticRenderFns } from "./NewYears_defaultSection.vue?vue&type=template&id=4adc2586&scoped=true"
import script from "./NewYears_defaultSection.vue?vue&type=script&lang=ts"
export * from "./NewYears_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./NewYears_defaultSection.vue?vue&type=style&index=0&id=4adc2586&prod&lang=css"
import style1 from "./NewYears_defaultSection.vue?vue&type=style&index=1&id=4adc2586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc2586",
  null
  
)

export default component.exports